import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { hasLoggedUserElevatedPermissions } from "~/store/selectors/selector.users.jsx";
import AddToTaskTrigger from "../tasks/AddToTaskTrigger.jsx";

const AddSubtaskTriggerContainer = ({ visible, handleOnClick, classname }) => {
  const { t } = useTranslation();

  const canModify = useSelector(hasLoggedUserElevatedPermissions);
  if (!canModify || !visible) return null;

  return (
    <AddToTaskTrigger
      handleOnClick={handleOnClick}
      labelText={t("Add a Subtask")}
      className={classname}
    />
  );
};

AddSubtaskTriggerContainer.propTypes = {
  handleOnClick: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  classname: PropTypes.string,
};

AddSubtaskTriggerContainer.defaultProps = {
  visible: false,
};

AddSubtaskTriggerContainer.displayName = `AddToTaskTrigger`;

export default AddSubtaskTriggerContainer;
